enum AudioPlayerType {
  MP3 = 'audio/mpeg',
  OGG = 'audio/ogg',
  WAV = 'audio/wav',
}
export { AudioPlayerType };
